<template>
    <div v-prefix :class="{ 'is-toggled': value, }" :aria-hidden="value ? 'false' : 'true'" class="#main-header-menu-filter bg-white pa-3" stop-propogation>
        <div class="flex flex-wrap">
            <div class="x-small-12 medium-6 pa-1">
                <label for="filters-sport" class="sidearm-galleries-label">Sport:</label>

                <icon-wrapper icon="sf-arrow-down-minimal" size="1.5rem">
                    <select v-model="selected_sport_id" id="filters-sport" class="sidearm-galleries-select" :tabindex="value ? '0' : '-1'">
                        <option v-for="sport in sports" :key="sport.id" :value="sport.id">{{ sport.title }}</option>
                    </select>
                </icon-wrapper>
            </div>

            <div class="x-small-12 medium-6 pa-1">
                <label for="filters-season" class="sidearm-galleries-label">Season:</label>

                <icon-wrapper icon="sf-arrow-down-minimal" size="1.5rem">
                    <select v-model="selected_season_id" id="filters-sport" class="sidearm-galleries-select" :tabindex="value ? '0' : '-1'">
                        <option v-for="season in seasons" :key="season.id" :value="season.id">{{ season.title }}</option>
                    </select>
                </icon-wrapper>
            </div>

            <div class="x-small-12 medium-6 pa-1">
                <label for="filters-season" class="sidearm-galleries-label">Tags:</label>

                <filter-popover-tag-search v-model="tags" />
            </div>

            <div class="x-small-12 medium-6 pa-1">
                <label for="filters-season" class="sidearm-galleries-label">Players:</label>

                <filter-popover-player-search v-model="players" />
            </div>

            <div class="x-small-12 px-1 mt-1">
                <button @click="save_filters" type="button" class="sidearm-galleries-btn --primary block w-100 type-base text-normal py-1" :tabindex="value ? '0' : '-1'">Apply Filters</button>
            </div>

            <div class="x-small-12 px-1 my-1 text-center">
                <button @click="clear_filters" type="button" class="reset type-small" :tabindex="value ? '0' : '-1'">Reset</button>
            </div>
        </div>

    </div>
</template>

<script>
    import FilterPopoverPlayerSearch from '@/components/FilterPopoverPlayerSearch.vue'
    import FilterPopoverTagSearch from '@/components/FilterPopoverTagSearch.vue'

    import api from '@/api'
    import { mapState, mapActions } from 'vuex'

    export default {
        props: {
            value: {
                type: Boolean,
                required: true,
                default: false,
            },
        },

        components: {
            FilterPopoverPlayerSearch,
            FilterPopoverTagSearch,
        },

        data: () => ({
            selected_sport_id: 0,

            selected_season_id: 0,

            tags: [],

            players: [],
        }),

        computed: {
            ...mapState({
                _sports: state => state.sports,
                _seasons: state => state.seasons,
            }),

            sports() {
                let sports = this._sports.slice();

                sports.unshift({
                    id: 0,
                    title: 'All Sports'
                });

                return sports;
            },

            seasons() {
                let seasons = this._seasons.slice();

                seasons.unshift({
                    id: 0,
                    title: 'All Seasons',
                });

                return seasons;
            }
        },

        methods: {
            ...mapActions([
                'set_filters',
            ]),

            close_dialog() {
                this.$emit('input', false);
            },

            save_filters() {
                const filters = {
                    sport_id: this.selected_sport_id,
                    season_id: this.selected_season_id,
                    player_ids: this.players.map(player => player.id).join(','),
                    tag_ids: this.tags.map(tag => tag.id).join(','),
                };

                this.set_filters(filters);

                this.close_dialog();
            },

            clear_filters() {
                this.selected_sport_id = 0;
                this.selected_season_id = 0;
                this.players = [];
                this.tags = [];

                this.save_filters();
            }
        },

        created() {
            
        }
    }
</script>

<style lang="scss" scoped>
    .#{$prefix}__main-header-menu-filter {
        @include hide();
        
        box-shadow: 0px 1px $spacer rgba($color-black, 0.08);
        opacity: 0;
        transition: opacity .35s;

        &.is-toggled {
            @include unhide();

            display: block;
            height: auto;
            left: 0;
            max-width: 720px;
            overflow: visible;
            opacity: 1;
            position: absolute;
            top: 100%;
            transform: translateY($spacer*-2);
            width: 100%;
            z-index: 100;
        }

        @media (max-width: #{$breakpoint-medium-down}) {
            padding: $spacer;
        }
    }
</style>